import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch, useHistory, useParams } from "react-router-dom";
import classnames from "classnames";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import { State } from "../../interfaces";
import { SelectListDto } from "../../models";
import { BreadCrumb } from "../../components/Common";
import { getCourseSelectList } from "../../store/actions";
import { OlympicsPage, OlympicQuestionsPage } from "./";
import { OlympicParticipantPage } from "./OlympicParticipantsPage";

type TProps = {};
export const OlympicTabsPage: React.FC<TProps> = () => {
  //#region hooks
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const { courseId } = useParams<any>();
  //#endregion

  //#region redux state

  const { response: courses } = useSelector(
    (state: any): State<SelectListDto[]> => state.course.courseSelectList
  );
  //#endregion

  //#region handlers

  const onClickCourse = (_courseId: string) => {
    history.push(`/olympiad/${_courseId}`);
  };

  //#endregion

  //#region effects

  useEffect(() => {
    dispatch(getCourseSelectList());
  }, []);

  useEffect(() => {
    if (courses && courses.length > 0)
      if (!courseId) history.replace(`/olympiad/${courses[0].id}`);
  }, [courses]);

  //#endregion

  document.title = `${t("documentTitle", { pageName: "olympiad" })}`;

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("olympiad")} pageTitle={t("")} />
          <Row>
            <Col xxl={12}>
              <Card className="m-0">
                <CardBody>
                  <Nav pills className="nav-success">
                    {courses &&
                      courses.length > 0 &&
                      courses?.map((course: SelectListDto, index: number) => (
                        <NavItem key={index}>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: courseId == course.id,
                            })}
                            onClick={() => {
                              onClickCourse(course.id);
                            }}
                          >
                            {i18n.language === "ar"
                              ? course.value.ar
                              : course.value.en}
                          </NavLink>
                        </NavItem>
                      ))}
                  </Nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <React.Fragment>
            <Switch>
              <Route
                exact={true}
                path="/olympiad/:courseId"
                component={OlympicsPage}
              />
              <Route
                exact={true}
                path="/olympiad/questions/:courseId/:olympicId"
                component={OlympicQuestionsPage}
              />
              <Route
                exact={true}
                path="/olympiad/participants/:courseId/:olympicId"
                component={OlympicParticipantPage}
              />
            </Switch>
          </React.Fragment>
        </Container>
      </div>
    </React.Fragment>
  );
};
